module.exports = __webpack_public_path__ + "static/media/upload-guide.e520064c.png";